// @ts-nocheck
/* eslint-disable */
export const llaPlatformArrowRightIcon = {
    data: `<svg viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.03003 0.51001L8.53003 8.01001L1.03003 15.51" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    name: 'arrow-right' as const
};